import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import UNIVERSAL from "../config/config";

const initialState = {
  data: "",
  campaign: "" ,
  loading: true,
  adCopiesLoading: false,
  error: "",
};

export const fetchAllCampaignDetails = createAsyncThunk("/campaigns/fetchAllCamapignDetails", (data) => {
  return fetch(`${UNIVERSAL.BASEURL_1}/campaigns/listCampaign`, {
    method: "POST",
    headers: {
      'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
    },
    body :JSON.stringify({
      ...data
    })
  })
    .then((response) => response.json())
    .then((res) => {
      return res.data;
    });
});


export const fetchCampaignDetails = createAsyncThunk("/campaigns/getCampaign", (data) => {
  return fetch(`${UNIVERSAL.BASEURL_1}/campaigns/getCampaign`, {
    method: "POST",
    headers: {
      'x-api-key': '6gZ2J0WfUx9iAmKIwvwG3NiX1783yn094tzrssHe',
    },
    body :JSON.stringify({
      ...data
    })
  })
    .then((response) => response.json())
    .then((res) => {
      return res.data;
    });
});

const campaignSlice = createSlice({
  name: "allCampaign",
  initialState,
  reducers: {
    resetCampaigns: (state, action) => {
      state.data = "";
    },
  },

  extraReducers: (builder) => {
    builder.addCase(fetchAllCampaignDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllCampaignDetails.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action.payload;
      state.error = "";
    });
    builder.addCase(fetchAllCampaignDetails.rejected, (state, action) => {
      state.loading = false;
      state.data = "";
      state.error = action.error.message;
    });
    builder.addCase(fetchCampaignDetails.pending, (state) => {
      state.adCopiesLoading = true;
    });
    builder.addCase(fetchCampaignDetails.fulfilled, (state, action) => {
      state.adCopiesLoading = false;
      state.campaign = action.payload;
      state.error = "";
    });
    builder.addCase(fetchCampaignDetails.rejected, (state, action) => {
      state.adCopiesLoading = false;
      state.campaign = "";
      state.error = action.error.message;
    });
  },
});

export default campaignSlice;

export const { resetCampaigns } = campaignSlice.actions;
